import { SERVER_ROUTES } from "../../enums/Enums";
import * as axiosActions from "../../managers/Axios/AxiosActions";
import { trackException } from "../Azure/ApplicationInsightsActions";


export const getMailingListsBySiteId = (siteId, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
    var queryParams = siteId;

    axiosActions
        .GET(SERVER_ROUTES.MAILING_LISTS, queryParams, isShowSpinner, closeSpinner)
        .then((response) => {
            resolve(response);
        })
        .catch((error) => {
            trackException(
                "ActionsService.js - getMailingListsBySiteId()",
                error
            );
            reject(error);
        });
    });
};

export const addMailingList = (createMailingList, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
    var body = createMailingList;

      axiosActions
        .POST(SERVER_ROUTES.MAILING_LISTS, body, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException("ActionsService.js - addMailingList()", error);
          reject(error);
        });
    });
  };

  export const updateMailingList = (updateMailingList) => {
    return new Promise((resolve, reject) => {
    var body = updateMailingList;

      axiosActions
        .PUT(SERVER_ROUTES.MAILING_LISTS, body)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException("ActionsService.js - updateMailingList()", error);
          reject(error);
        });
    });
  };

  export const deleteMailingList = (mailingListId, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
      var queryParams = mailingListId;
  
      axiosActions
        .DELETE(SERVER_ROUTES.MAILING_LISTS + queryParams, null, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException("ActionsService.js - deleteMailingList()", error);
          reject(error);
        });
    });
  };

  // Camapigns
  export const getCampaignsBySiteId = (siteId, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
    var queryParams = siteId;

    axiosActions
        .GET(SERVER_ROUTES.CAMPAIGN, queryParams, isShowSpinner, closeSpinner)
        .then((response) => {
            resolve(response);
        })
        .catch((error) => {
            trackException(
                "ActionsService.js - getCampaignsBySiteId()",
                error
            );
            reject(error);
        });
    });
};

export const getCampaignAttachmentById = (id, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
  var queryParams = id;

  axiosActions
      .GET(SERVER_ROUTES.GET_CAMPAIGN_ATTACHMENT_BY_ID, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
          resolve(response);
      })
      .catch((error) => {
          trackException(
              "ActionsService.js - getCampaignAttachmentById()",
              error
          );
          reject(error);
      });
  });
};

export const addCampaign = (campaign, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
  var body = campaign;

    axiosActions
      .POST(SERVER_ROUTES.CAMPAIGN, body, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("ActionsService.js - addCampaign()", error);
        reject(error);
      });
  });
};

export const updateCampaign = (campaign) => {
  return new Promise((resolve, reject) => {
  var body = campaign;

    axiosActions
      .PUT(SERVER_ROUTES.CAMPAIGN, body)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("ActionsService.js - updateCampaign()", error);
        reject(error);
      });
  });
};

export const deleteCampaign = (campaignId, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams = campaignId;

    axiosActions
      .DELETE(SERVER_ROUTES.CAMPAIGN + queryParams, null, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("ActionsService.js - deleteCampaign()", error);
        reject(error);
      });
  });
};

export const sendCampaign = (sendCampaignOperationsEntity, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
  var body = sendCampaignOperationsEntity;

    axiosActions
      .POST(SERVER_ROUTES.CAMPAIGN + "SendCampaign", body, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("ActionsService.js - sendCampaign()", error);
        reject(error);
      });
  });
};

// Messaging cost
export const getMessagingCosts = (isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
  var queryParams = "";

  axiosActions
      .GET(SERVER_ROUTES.MESSAGING_COST, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
          resolve(response);
      })
      .catch((error) => {
          trackException(
              "ActionsService.js - getMessagingCosts()",
              error
          );
          reject(error);
      });
  });
};

export const getMessagingCostsBySiteId = (siteId, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
  var queryParams = siteId;

  axiosActions
      .GET(SERVER_ROUTES.MESSAGING_COST, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
          resolve(response);
      })
      .catch((error) => {
          trackException(
              "ActionsService.js - getMessagingCostsBySiteId()",
              error
          );
          reject(error);
      });
  });
};

// Messaging history
export const getMessagingHistoriesByCampaignsIds = (campaignsIds, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = campaignsIds;

    axiosActions
      .POST(SERVER_ROUTES.MESSAGING_HISTORY_BY_CAMPAIGNS_IDS, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getMessagingHistoriesByCampaignsIds()",
          error
        );
        reject(error);
      });
  });
};

// Messaging history to mailing list
export const getMessagingHistoryToMailingListsByMessagingHistoryIds = (messagingHistoryIds, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = messagingHistoryIds;

    axiosActions
      .POST(SERVER_ROUTES.MESSAGING_HISTORY_TO_MAILING_LIST_BY_MESSAGING_HISTORY_IDS, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getMessagingHistoryToMailingListsByMessagingHistoryIds()",
          error
        );
        reject(error);
      });
  });
};